module.exports = __webpack_public_path__ + "static/media/checkmark-large.9f0deae5.svg";